const pad = (value: number) => String(value).padStart(2, '0');

/** Heatmap row label: "1 PM" in English, "13h" in Portuguese. */
export function formatHourLabel(hour: number, locale: string): string {
  if (locale.startsWith('pt')) return `${pad(hour)}h`;
  return `${hour % 12 || 12} ${hour < 12 ? 'AM' : 'PM'}`;
}

/** The whole local hour a heatmap cell covers, e.g. "14:00–14:59". */
export function formatHourRange(hour: number): string {
  return `${pad(hour)}:00–${pad(hour)}:59`;
}
